// frontend/src/utils/purchaseOrderApi.js

import { apiFetch } from './api';

const PO_ENDPOINT = '/purchase-orders';

export const getPurchaseOrders = async () => {
  const response = await apiFetch(`${PO_ENDPOINT}/`);
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || '仕入伝票の取得に失敗しました');
  }
  return response.json();
};

export const createPurchaseOrder = async (poData) => {
  const response = await apiFetch(`${PO_ENDPOINT}/`, {
    method: 'POST',
    body: JSON.stringify(poData),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || '仕入伝票の作成に失敗しました');
  }
  return response.json();
};

// 必要に応じて update や delete もここに追加します

export const searchVariants = async (query, supplierUuid) => {
  if (!query || !supplierUuid) return [];

  // 🌟 クエリパラメータとして query と supplier_uuid を渡します
  const url = `${PO_ENDPOINT}/search-variants?query=${encodeURIComponent(query)}&supplier_uuid=${encodeURIComponent(supplierUuid)}`;
  const response = await apiFetch(url);

  if (!response.ok) {
    console.error('商品検索に失敗しました');
    return [];
  }
  return response.json();
};

// frontend/src/utils/purchaseOrderApi.js の末尾に追加

export const searchProductsForModal = async (query, supplierUuid) => {
  if (!query || !supplierUuid) return [];

  const url = `/purchase-orders/search-products?query=${encodeURIComponent(query)}&supplier_uuid=${encodeURIComponent(supplierUuid)}`;
  const response = await apiFetch(url);

  if (!response.ok) {
    console.error('商品検索に失敗しました');
    return [];
  }
  return response.json();
};

export const getNextPoNumber = async () => {
  try {
    const response = await apiFetch('/purchase-orders/next-number');

    // 🌟 APIのレスポンスが正常かチェック
    if (!response.ok) {
      console.error('連番APIエラー:', response.statusText);
      return '';
    }

    // 🌟 ここが抜けていました！JSONとして中身を取り出す
    const data = await response.json();

    // 確実に取り出して返す
    return data.next_order_number || '';
  } catch (error) {
    console.error('連番取得エラー:', error);
    return '';
  }
};

/**
 * 税区分コード（STANDARD等）から現在適用される税率を取得する
 */
export const getActiveTaxRate = async (taxCode = 'STANDARD') => {
  try {
    const response = await apiFetch(`/systems/tax-settings/active?tax_code=${taxCode}`);
    if (!response.ok) throw new Error('税率の取得に失敗しました');

    // 🌟 防衛策: 返ってきたデータがJSONじゃなければパースせずに弾く
    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      throw new Error('API未実装のため、サーバーからHTMLが返されました');
    }

    const data = await response.json();
    return parseFloat(data.tax_rate);
  } catch (error) {
    // 制御された綺麗なエラーログだけを残す
    console.warn('【税率取得フォールバック】:', error.message);
    return 0.10; // APIが完成するまでは安全に10%を返す
  }
};